import PropTypes from 'prop-types';

import { Select } from 'hb-react/shared/components/formik/components/inputs';

const Periodicity = ({ enabled, periodicities }) =>
  enabled ? (
    <div className="push--top one-half palm--one-whole soft--left bordered--left border-color--mediumgray border-width--2">
      <Select
        name="donation_order[periodicity]"
        label={s__('donations|I will give every...')}
        validate={{
          required: true,
        }}
        options={periodicities}
        isNotSearchable
      />
    </div>
  ) : null;

Periodicity.propTypes = {
  enabled: PropTypes.bool,
  periodicities: PropTypes.array,
};

export default Periodicity;
